module.exports = __webpack_public_path__ + "img/Flag_of_Nepal.e79af026.svg";